import { AccountInfo, IPublicClientApplication, OIDC_DEFAULT_SCOPES } from "@azure/msal-browser"

// export default class AuthContext {
//     constructor() {
//         this.azureClientId = '',
//         this.azureTenantId = '',
//         publicClientApplication = undefined,
//         account = undefined,
//         isInitialized = false,
//         scopes = OIDC_DEFAULT_SCOPES
//     }
// }

export const createAuthContext = () => ({
  azureClientId: '',
  azureTenantId: '',
  publicClientApplication: undefined,
  account: undefined,
  isInitialized: false,
  scopes: OIDC_DEFAULT_SCOPES,
});